// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/node_modules/.pnpm/next@16.1.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/esm/client/components/client-page.js <module evaluation>"));
